import { render, staticRenderFns } from "./B2CV2DailyPanel.vue?vue&type=template&id=867b4992&scoped=true&"
import script from "./B2CV2DailyPanel.vue?vue&type=script&lang=js&"
export * from "./B2CV2DailyPanel.vue?vue&type=script&lang=js&"
import style0 from "./B2CV2DailyPanel.vue?vue&type=style&index=0&id=867b4992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867b4992",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VProgressCircular,VSelect,VSpacer})
